import { createTRPCReact, httpBatchLink } from '@trpc/react-query';
import type { AppRouter } from '@cdvi-edge/api';
import { stackApp } from './stack.ts';

export const trpc = createTRPCReact<AppRouter>();

const apiBase = import.meta.env.VITE_WORKER_URL ?? '';

export function createTrpcClient(getStackTeamId: () => string | null) {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: `${apiBase}/trpc`,
        async headers() {
          const user = await stackApp.getUser();
          const headers: Record<string, string> = {};
          if (user) {
            const { accessToken } = await user.getAuthJson();
            if (accessToken) headers.authorization = `Bearer ${accessToken}`;
          }
          const teamId = getStackTeamId();
          if (teamId) headers['x-stack-team-id'] = teamId;
          return headers;
        },
      }),
    ],
  });
}
